import React, { useContext, useMemo } from 'react'
import { ReactTable } from "../../Molecules";
import { ALERT_VEHICLE_TABLE_HEADERS } from "../../../Library/tableHeaders";
import { StoreContext } from '../../../Library/contexts';
import { DEVICE_HWTYP_VALUES } from '../../../Library/constants';

const AlertsVehiclesTable = ({headers, className, handleRowSelect, selectedRows}) => {
  const { userVehicles } = useContext(StoreContext);  
  const tableColumns = useMemo(
    () =>
      Object.values(headers || ALERT_VEHICLE_TABLE_HEADERS).map((header) => {
        return {
          Header: header.nm,
          accessor: header.key,
          disableSortBy: !header.sorting,
          Cell: (row) => {
            if (row.column.id === "hwtyp") {
              let devName = DEVICE_HWTYP_VALUES[row.value];
              return (
                <span className="set-os-alert-cell">
                  {(row.value && devName) ? devName : DEVICE_HWTYP_VALUES[1]}
                </span>
              )
            }
            return <span className="set-os-alert-cell">
              {row.value}
            </span>
          },
        };
      }),
    [headers]
  );
  return (
    <div className={className}>
      <ReactTable
        columns={tableColumns}
        showSearch={true}
        heading={"Select Vehicle"}
        data={userVehicles || []}
        pageSize={10}
        showSelection={true}
        showSelectAll={true}
        checkboxLabel={"Select All"}
        onRowSelect={handleRowSelect}
        selectedRows={selectedRows}
      />
    </div>
  )
}

export default AlertsVehiclesTable